'use client';

import { cn } from '@/lib/utils';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
} from './ui/animated-modal';

// Tableau statique des avis
const staticReviews = [
  {
    authorName: 'K C',
    rating: 5,
    text: "Nathalia m'a apporté une écoute attentive et m'a apporté de précieux conseils concernant mon alimentation durant ma grossesse et pour le post partum. Elle prend son temps et répond à vos questions avec attention même hors sujet.Petit plus: les fiches techniques. Je recommande vivement!",
    relativeTime: 'Il y a 1 an',
  },
  {
    authorName: 'Marion Gadault',
    rating: 5,
    text: 'Si vous cherchez une naturopathe de confiance entre Clermont l’Hérault et Gignac, je vous recommande fortement de consulter Nathalia. Elle est passionnée par son métier et apporte de très bons conseils adaptés à vos besoins.',
    relativeTime: 'Il y a 1 an',
  },
  {
    authorName: 'Elsa Frandez',
    rating: 5,
    text: "Nathalia a su très rapidement me mettre à l'aise, par sa bienveillance et sa douceur. Après une évaluation très complète de mon état de fatigue, qui lui a permis d'identifier avec pertinence quelles en étaient les causes, Nathalia m'a proposé un plan d'actions adapté et personnalisé pour lutter contre mon épuisement. J'ai pu mettre en place rapidement et aisément les différents conseils qu'elle m'a prodigués et que j'applique encore au quotidien, ce qui a permis d'enclencher chez moi une dynamique très positive. Je remercie de tout cœur Nathalia pour son écoute de grande qualité et le temps qu'elle m'a consacré, et vous la recommande +++ ",
    relativeTime: 'Il y a 1 an',
  },
  {
    authorName: 'Anne Pavard',
    rating: 5,
    text: `J'ai fait appel à Nathalia un peu après la naissance de ma deuxième. Mon "grand" de 2 ans faisait crise sur crise, je me sentais stressée, épuisée, frustrée. Nathalia m'a énormément aidée, elle m'a proposé un plan d'action pour sortir de mon cercle vicieux.Résultat : 
        1) au niveau familial, on a retrouvé une belle harmonie et les moments de joie et de douceur sont beaucoup plus nombreux que les moments de tension, 
        2) au niveau du couple, une meilleure communication, 
        3) au niveau perso, je me sens vraiment mieux physiquement et psychologiquement. Bref, si vous aussi vous êtes une maman qui a besoin d'un coup de pouce, faites appel à Nathalia, elle saura vous proposer un accompagnement personnalisé, et elle a aussi cette faculté à poser les bons mots sur les maux ! Merci à toi :)`,
    relativeTime: 'Il y a 1 an',
  },
  {
    authorName: 'gwladys goury',
    rating: 5,
    text: "Nathalia à su se montrer à l'écoute et bienveillante. Elle vous conseillera en tenant compte de qui vous êtes et de où vous en êtes. Je recommande !",
    relativeTime: 'Il y a 11 mois',
  },
  {
    authorName: 'Nat Lieb',
    rating: 5,
    text: "J'ai consulté Nathalia car je cherchais des solutions naturelles pour m’aider dans mon désir de grossesse apres 2 echecs dont 1 assez difficile. Cette consultation a été une véritable bouffée d’air frais après cette épreuve difficile . Je me suis sentie comprise, soutenue et guidée avec beaucoup de douceur. Nous avons pu travailler ensemble sur un protocole specifique à mes besoins. Les conseils qu'elle m'a donnés sont très clairs et elle donne beaucoup d'astuce afin de faciliter la mise en place. Nathalia m'a redonné de l'espoir. Je recommande à toutes les femmes qui traversent ce chemin parfois difficile.",
    relativeTime: 'Il y a 4 mois',
  },
  {
    authorName: 'Mary-jo Cathala',
    rating: 5,
    text: "Nathalia est dans l'écoute et dans l'empathie qui donne confiance et maîtrise bien la transmission de ses connaissances. Depuis plus d'un an elle a su me mettre en accord avec moi même afin que je puisse maîtriser mes pulsions sans que ce soit pour moi une contrainte. Mon bien être physique étant là je peux grâce à elle maintenir ce bien-être et je suis sur le chemin de ma perte de poids. bravo Nathalia !.",
    relativeTime: 'Il y a 3 mois',
  },
  {
    authorName: 'Hulya Ribordy',
    rating: 5,
    text: "J'ai consulté Nathalia à Gignac lors de mes vacances dans la région (elle m'a été recommandée par une amie) Elle m'a donné des conseils vraiment adaptés, elle sait mettre des mots sur ce que je ressentais.. J'ai tellement apprécié son professionnalisme que nous continuons le suivi à distance en visio. Je la recommande à 100 %",
    relativeTime: 'Il y a 3 mois',
  },
  {
    authorName: 'France Dussurget',
    rating: 5,
    text: "J'ai consulté Nathalia car je souffrais de fatigue depuis des années. En seulement 3 séances, Nathalia a réussi à identifier mes carences et mettre en place un protocole efficace. En quelques semaines j'ai retrouvé une vitalité que je croyais perdue. La deuxième étape est de commencer un protocole de fertilité, je reposterai un avis dans quelques mois. Si vous cherchez une méthode naturelle pour retrouver de l'énergie, n'hésitez pas et contacter Nathalia qui en plus d'être pro est à l'écoute, sans jugement et sympathique.",
    relativeTime: 'Il y a 1 mois',
  },
  {
    authorName: 'Sankoukaye',
    rating: 5,
    text: 'Naturopathe très compétente, perspicace et professionnelle. Une oreille attentive et dotée d’un bon esprit d’analyse. Allez y en toute confiance.',
    relativeTime: 'Il y a 2 semaines',
  },
  {
    authorName: 'Eva Momenceau',
    rating: 5,
    text: `J'ai sollicité Nathalia dans un contexte de suspicion de TDAH pour mon fils de 10 ans.Dès le premier rendez- vous, je me suis sentie écoutée, comprise et surtout jamais jugée.Elle a pris le temps d’échanger longuement avec nous, de comprendre le fonctionnement de mon fils, son environnement, ses émotions et ses difficultés, avec beaucoup de bienveillance et de douceur.
    Son approche est globale, humaine et rassurante, autant pour l’enfant que pour le parent.Elle a su nous aiguiller, proposer des conseils et ajustements concrets, adaptés à son âge et faciles à mettre en place au quotidien.
    Grâce à son suivi, j’ai gagné en compréhension, en sérénité et surtout en confiance pour accompagner mon fils de la meilleure façon possible.
    Le cabinet est intimiste, dans les locaux neufs du pôle santé de Gignac, donc idéalement situé.S'y garer est très facile.`,
    relativeTime: 'Il y a 2 jours',
  },
];

const GoogleReviews = () => {
  return (
    <div className="shadow-lg rounded-2xl p-8 mx-0 mt-0 mb-0">
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
        Avis <span className="text-[#4285F4]">G</span>
        <span className="text-[#EA4335]">o</span>
        <span className="text-[#FBBC05]">o</span>
        <span className="text-[#4285F4]">g</span>
        <span className="text-[#34A853]">l</span>
        <span className="text-[#EA4335]">e</span>
      </h2>

      <div className="relative overflow-hidden">
        <Marquee>
          {staticReviews.map((review, index) => (
            <ReviewCard key={index} review={review} />
          ))}
        </Marquee>
      </div>
    </div>
  );
};

const Marquee = ({ children }) => {
  return (
    <div className="relative flex overflow-hidden">
      {/* Premier ensemble de cartes */}
      <div className="flex animate-marquee">{children}</div>
      {/* Deuxième ensemble de cartes (dupliqué) */}
      <div className="flex absolute top-0 animate-marquee2">{children}</div>
    </div>
  );
};

const ReviewCard = ({ review }) => {
  return (
    <div className="w-[300px] p-2 shrink-0">
      {' '}
      {/* Largeur fixe sans padding */}
      <Modal>
        <figure
          className={cn(
            'w-full rounded-xl p-4',
            'border border-gray-200 bg-gradient-to-br from-gray-50 to-gray-100',
            'hover:shadow-md transition-shadow duration-300'
          )}
        >
          <div className="flex flex-row items-center gap-4 mb-4">
            <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center">
              <span className="text-gray-600 font-bold text-xl">
                {review.authorName ? review.authorName[0] : '?'}
              </span>
            </div>
            <div className="flex flex-col">
              <figcaption className="text-lg font-semibold text-gray-800">
                {review.authorName}
              </figcaption>
              <p className="text-sm text-gray-500">{review.relativeTime}</p>
            </div>
          </div>
          <div className="text-yellow-500 text-lg font-semibold mb-4">
            {'★'.repeat(review.rating)}
            {'☆'.repeat(5 - review.rating)}
          </div>
          <blockquote className="text-gray-700 text-sm leading-relaxed line-clamp-3">
            {review.text}
          </blockquote>
          {review.text.length > 100 && (
            <button className="mt-2 text-sm text-[#4285F4] hover:text-[#EA4335] transition-colors duration-200">
              Lire la suite...
            </button>
          )}
        </figure>

        <ModalBody>
          <ModalContent>
            <div className="p-6">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 bg-gray-200 rounded-full flex items-center justify-center">
                  <span className="text-gray-600 font-bold text-2xl">
                    {review.authorName ? review.authorName[0] : '?'}
                  </span>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-200">
                    {review.authorName}
                  </h3>
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    {review.relativeTime}
                  </p>
                </div>
              </div>
              <div className="text-yellow-500 text-xl font-semibold mb-4">
                {'★'.repeat(review.rating)}
                {'☆'.repeat(5 - review.rating)}
              </div>
              <blockquote className="text-gray-700 dark:text-gray-300 text-base leading-relaxed">
                {review.text}
              </blockquote>
            </div>
          </ModalContent>
          <ModalFooter />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default GoogleReviews;
